import _ from 'lodash';
import PropTypes from 'prop-types';
import React, {Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles/index';
import red from '@material-ui/core/colors/red';
import Transition from './Transition';
import FMPText from "../pureForm/FMPText";

const styles = (theme) => ({
	dialogPadding : {
		padding : 10,
		[theme.breakpoints.up('md')]: {
			padding : '20px 50px 20px 50px',
		}
	},
	dialogPaper : {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	question : {
		padding: '20px 20px 10px 20px',
		fontWeight : 600,
		fontSize : 16,
		textAlign : 'right',
	},
	actions : {
		padding : 10,
	},
	originalReason : {
		padding : '0 0 10px 0',
		fontStyle : 'italic',
	},
	listHeader : {
		paddingTop : 10,
		fontWeight : 600,
	},
	list : {
		marginTop : 5,
		marginBottom : 5,
		paddingLeft : 25,
	},
	noEmailWarning : {
		marginTop : 10,
		padding : 10,
		fontWeight : 600,
		backgroundColor : red[50],
		border : `1px solid ${red[200]}`,
		borderRadius : 4,
	},
	warningButton : {
		borderRadius : 100,
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[700],
		},
	},
});


class ConfirmUncancelDeliveryDialog extends Component {

	constructor (props) {
		super(props);
		this.state = {
			reason : '',
		};
	}

	handlePureChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		this.setState(newState);
	};

	getInputProps = (path, md, defaultValue) => {
		return {
			path,
			value  : this.getValue(path, defaultValue),
			error : this.getError(path),
			onChange : this.handlePureChange,
			md : md || 6,
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		const val = _.get(this.state, path, _d);
		return (_.isNull(val)) ? '' : val;
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	handleClose = () => {
		this.props.onClose();
	};

	handleUncancelDelivery = () => {
		const {
			uncancelDelivery,
			onClose,
			stationDelivery,
			showErrors
		} = this.props;
		const { reason } = this.state;

		if (!reason) {
			showErrors(['A reason for uncancelling is required.']);
			return;
		}

		if (!stationDelivery) {
			return showErrors(['Missing station delivery']);
		}

		const params = {
			stationDeliveryId : stationDelivery.stationDeliveryId,
			reason,
		};

		uncancelDelivery({
			params,
			callback : (err) => {
				if (!err) { onClose(); }
			}
		});
	};

	render() {
		const { classes, open, stationDelivery } = this.props;
		const cancellationReason = _.get(stationDelivery, 'cancellationReason');
		return (
			<Dialog
				maxWidth='md'
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper
				}}
			>
				<DialogTitle>Uncancel Delivery</DialogTitle>
				<DialogContent>
					{cancellationReason &&
					<div className={classes.originalReason}>
						Originally cancelled because: "{cancellationReason}"
					</div>
					}

					<FMPText
						{...this.getInputProps(`reason`)}
						label={'Reason for uncancelling delivery'}
					/>

					<div className={classes.listHeader}>
						Uncancelling WILL do the following:
					</div>
					<ul className={classes.list}>
						<li>
							The delivery becomes active again and reappears in delivery lists and
							carrier feeds.
						</li>
						<li>
							Status is reset to <strong>Pending Carrier Confirmation</strong> — the
							previous carrier confirmation is wiped out.
						</li>
						<li>The stored cancellation reason is erased.</li>
						<li>
							Any station invoice that was invalidated by the cancellation is restored
							back to pending.
						</li>
						<li>
							Inventory balances for the affected terminal and month are flagged for
							recalculation.
						</li>
						<li>
							A delivery history entry is written with your name and the reason you
							enter above.
						</li>
					</ul>

					<div className={classes.noEmailWarning}>
						Uncancelling does NOT send any emails. The carrier, station, terminal, and
						supplier will NOT be notified, and the original cancellation email is not
						retracted. Reach out to them yourself, or use "Update : Send Change Request"
						after uncancelling.
					</div>

				</DialogContent>

				<div className={classes.question}>
					Are you sure you want to uncancel this delivery?
				</div>

				<DialogActions>
					<div className={classes.actions}>
						<Button onClick={this.handleClose}>
							Close
						</Button>
						<Button
							variant="contained"
							onClick={this.handleUncancelDelivery}
							className={classes.warningButton}
						>
							Yes, uncancel delivery
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

ConfirmUncancelDeliveryDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,

	stationDelivery : PropTypes.object,

	uncancelDelivery : PropTypes.func.isRequired,
	showErrors : PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
])(ConfirmUncancelDeliveryDialog);
